// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zjYQ72AraS6Xdx_olYs7{background:red;color:#fff;font-family:"Open Sans",sans-serif;padding:4px 8px;border-radius:4px;font-weight:bold;margin-bottom:30px;text-align:center}`, "",{"version":3,"sources":["webpack://./node_modules/@extensiv/shared-reactcomponents/dist/components/ErrorBanner/ErrorBanner.module.scss"],"names":[],"mappings":"AAEA,sBACE,cAAA,CACA,UAAA,CACA,kCAAA,CACA,eAAA,CACA,iBAAA,CACA,gBAAA,CACA,kBAAA,CACA,iBAAA","sourcesContent":["@use '../../assets/styles/theme.module.scss' as theme;\n\n.ErrorBanner {\n  background: theme.color(red);\n  color: theme.color(white);\n  font-family: 'Open Sans', sans-serif;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-weight: bold;\n  margin-bottom: 30px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primaryColor": `#008895`,
	"primaryColorMidTransparent": `#59b2bb`,
	"primaryColorTransparent": `rgba(0,137,149,.3058823529)`,
	"secondaryColor": `#ed40a9`,
	"secondaryColorTransparent": `rgba(237,64,168,.462745098)`,
	"cardTitleBackground": `#839fb0`,
	"searchButtonBackground": `#5b7e96`,
	"backdropBackground": `#22323e`,
	"white": `#fff`,
	"darkWhite": `#f7f7f7`,
	"black": `#000`,
	"lightGrey": `#f4f4f4`,
	"lightGrey2": `#f2f2f2`,
	"medGrey": `#e4e4e4`,
	"darkGrey": `#c4c4c4`,
	"midDarkGrey": `#bbb`,
	"extraDarkGrey": `#bebebe`,
	"red": `red`,
	"blue": `#007fff`,
	"linkBlue": `#0d7cce`,
	"blueGrey": `#bbc6d0`,
	"lightPurple": `#f0f2ff`,
	"tableRow": `#c1e9ed`,
	"columnHeader": `#d4dde4`,
	"columnHeaderTitle": `#222`,
	"ErrorBanner": `zjYQ72AraS6Xdx_olYs7`
};
export default ___CSS_LOADER_EXPORT___;
